import { render } from "./VerpackungPage.vue?vue&type=template&id=2d0af231"
import script from "./VerpackungPage.vue?vue&type=script&lang=js"
export * from "./VerpackungPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__